import type React from "react";
import { Button, Grid, Badge } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import { makeStyles } from '@mui/styles';
import Grid2 from '@mui/material/Grid2';

const useStyles = makeStyles({
	folderIcon: {
		color: "#FFC107",
	},
});

interface Props {
	params: any;
	onResourcesClick: (rowData: any) => void;
}

export const WorkOrdersResourcesColumn: React.FC<Props> = ({
	params,
	onResourcesClick,
}) => {
	const classes = useStyles();
	const handleClick = () => {
		onResourcesClick(params.data);
	};

	const resourceCount = params.data?.ResourcesCount || 0;

	return (
		<Grid2 spacing={1}
			style={{ justifyContent: "flex-end", minWidth: 30 }}>
			<Grid2 size={{ xs: 12, md: 12 }}>
				<Button fullWidth style={{}} onClick={handleClick}>
					<Badge
						badgeContent={resourceCount}
						color="primary"
						overlap="circular"
						anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
						sx={{
							"& .MuiBadge-badge": {
								fontSize: "0.6rem",
								height: 15,
								minWidth: 15,
								padding: "0 3px",
								// Pull the badge back over the folder corner so the cell does not clip it.
								transform: "scale(1) translate(calc(25% + 1px), 25%)",
							},
						}}>
						<FolderIcon
							className={classes.folderIcon}
							style={{ height: "auto", marginTop: "-2px" }} />
					</Badge>
				</Button>
			</Grid2>
		</Grid2>
	);
};
